import axios from "axios";
import { logWarn } from "@/lib/logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Firefox Total Cookie Protection and Safari ITP can block cross-site cookies
// even with SameSite=None. As a resilient fallback, we mirror the session
// token into localStorage on login/register/verify-email/OAuth and forward it
// as `Authorization: Bearer <token>` on every request. The backend already
// accepts both cookie AND bearer (see get_current_user in server.py).
const AARON_SESSION_KEY = "aaron_session_token";

export function saveSessionToken(token) {
  if (!token) return;
  try {
    localStorage.setItem(AARON_SESSION_KEY, token);
  } catch (e) {
    // Firefox/Safari private mode disables localStorage — auth still works via cookie.
    logWarn("saveSessionToken: localStorage unavailable", e?.message);
  }
}

export function clearSessionToken() {
  try {
    localStorage.removeItem(AARON_SESSION_KEY);
  } catch (e) {
    logWarn("clearSessionToken: localStorage unavailable", e?.message);
  }
}

export function readSessionToken() {
  try {
    return localStorage.getItem(AARON_SESSION_KEY);
  } catch (e) {
    logWarn("readSessionToken: localStorage unavailable", e?.message);
    return null;
  }
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = readSessionToken();
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// If any request returns 401, drop the local token so we don't loop on it.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) clearSessionToken();
    return Promise.reject(err);
  },
);

export const fileUrl = (fileId) => `${API}/files/${fileId}`;
